import "../phaser.min.js";
import Common from "../Includes/Common.js";

class CarSelection extends Phaser.Scene {

    constructor() {
        super('CarSelection');
        this.common = new Common();
    }

    init(data) {
        this.carOptions =
                [
                    [
                        {
                            key: 'car1-blue',
                            sprite: null,
                            drivingAnimation: 'car1-blue-driving'
                        },
                        {
                            key: 'car1-orange',
                            sprite: null,
                            drivingAnimation: 'car1-orange-driving'

                        },
                        {
                            key: 'car1-green',
                            sprite: null,
                            drivingAnimation: 'car1-green-driving'
                        },
                        {
                            key: 'car1-pink',
                            sprite: null,
                            drivingAnimation: 'car1-pink-driving'

                        },
                        {
                            key: 'car1-teal',
                            sprite: null,
                            drivingAnimation: 'car1-teal-driving'

                        }
                    ],
                    [
                        {
                            key: 'car2-blue',
                            sprite: null,
                            drivingAnimation: 'car2-blue-driving'
                        },
                        {
                            key: 'car2-orange',
                            sprite: null,
                            drivingAnimation: 'car2-orange-driving'

                        },
                        {
                            key: 'car2-green',
                            sprite: null,
                            drivingAnimation: 'car2-green-driving'
                        },
                        {
                            key: 'car2-pink',
                            sprite: null,
                            drivingAnimation: 'car2-pink-driving'

                        },
                        {
                            key: 'car2-teal',
                            sprite: null,
                            drivingAnimation: 'car2-teal-driving'

                        },
                    ],
                    [
                        {
                            key: 'convertible-blue',
                            sprite: null,
                            drivingAnimation: 'convertible-blue-driving'
                        },
                        {
                            key: 'convertible-orange',
                            sprite: null,
                            drivingAnimation: 'convertible-orange-driving'
                        },
                        {
                            key: 'convertible-green',
                            sprite: null,
                            drivingAnimation: 'convertible-green-driving'
                        },
                        {
                            key: 'convertible-pink',
                            sprite: null,
                            drivingAnimation: 'convertible-pink-driving'
                        },
                        {
                            key: 'convertible-teal',
                            sprite: null,
                            drivingAnimation: 'convertible-teal-driving'
                        }
                    ],
                    [
                        {
                            key: 'racecar-blue',
                            sprite: null,
                            drivingAnimation: 'racecar-blue-driving'
                        },
                        {
                            key: 'racecar-orange',
                            sprite: null,
                            drivingAnimation: 'racecar-orange-driving'
                        },
                        {
                            key: 'racecar-green',
                            sprite: null,
                            drivingAnimation: 'racecar-green-driving'
                        },
                        {
                            key: 'racecar-pink',
                            sprite: null,
                            drivingAnimation: 'racecar-pink-driving'
                        },
                        {
                            key: 'racecar-teal',
                            sprite: null,
                            drivingAnimation: 'racecar-teal-driving'
                        },
                    ]
                ];
        this.carIndex = 0;
        this.colorIndex = 0;
        this.selectedCar = null;
        this.carY = this.scale.height / 12 * 5.9;
    }

    preload() {
        const assetsPath = this.common.assetsPath;
        this.load.atlas('car1-blue-atlas', assetsPath + 'sprites/cars/car1-blue.png', assetsPath + 'sprites/cars/car1-blue.json')
        this.load.atlas('car1-orange-atlas', assetsPath + 'sprites/cars/car1-orange.png', assetsPath + 'sprites/cars/car1-orange.json')
        this.load.atlas('car1-green-atlas', assetsPath + 'sprites/cars/car1-green.png', assetsPath + 'sprites/cars/car1-green.json')
        this.load.atlas('car1-pink-atlas', assetsPath + 'sprites/cars/car1-pink.png', assetsPath + 'sprites/cars/car1-pink.json')
        this.load.atlas('car1-teal-atlas', assetsPath + 'sprites/cars/car1-teal.png', assetsPath + 'sprites/cars/car1-teal.json')
        this.load.atlas('car2-blue-atlas', assetsPath + 'sprites/cars/car2-blue.png', assetsPath + 'sprites/cars/car2-blue.json')
        this.load.atlas('car2-orange-atlas', assetsPath + 'sprites/cars/car2-orange.png', assetsPath + 'sprites/cars/car2-orange.json')
        this.load.atlas('car2-green-atlas', assetsPath + 'sprites/cars/car2-green.png', assetsPath + 'sprites/cars/car2-green.json')
        this.load.atlas('car2-pink-atlas', assetsPath + 'sprites/cars/car2-pink.png', assetsPath + 'sprites/cars/car2-pink.json')
        this.load.atlas('car2-teal-atlas', assetsPath + 'sprites/cars/car2-teal.png', assetsPath + 'sprites/cars/car2-teal.json')
        this.load.atlas('convertible-blue-atlas', assetsPath + 'sprites/cars/convertible-blue.png', assetsPath + 'sprites/cars/convertible-blue.json')
        this.load.atlas('convertible-green-atlas', assetsPath + 'sprites/cars/convertible-green.png', assetsPath + 'sprites/cars/convertible-green.json')
        this.load.atlas('convertible-orange-atlas', assetsPath + 'sprites/cars/convertible-orange.png', assetsPath + 'sprites/cars/convertible-orange.json')
        this.load.atlas('convertible-pink-atlas', assetsPath + 'sprites/cars/convertible-pink.png', assetsPath + 'sprites/cars/convertible-pink.json')
        this.load.atlas('convertible-teal-atlas', assetsPath + 'sprites/cars/convertible-teal.png', assetsPath + 'sprites/cars/convertible-teal.json')
        this.load.atlas('racecar-blue-atlas', assetsPath + 'sprites/cars/racecar-blue.png', assetsPath + 'sprites/cars/racecar-blue.json')
        this.load.atlas('racecar-green-atlas', assetsPath + 'sprites/cars/racecar-green.png', assetsPath + 'sprites/cars/racecar-green.json')
        this.load.atlas('racecar-orange-atlas', assetsPath + 'sprites/cars/racecar-orange.png', assetsPath + 'sprites/cars/racecar-orange.json')
        this.load.atlas('racecar-pink-atlas', assetsPath + 'sprites/cars/racecar-pink.png', assetsPath + 'sprites/cars/racecar-pink.json')
        this.load.atlas('racecar-teal-atlas', assetsPath + 'sprites/cars/racecar-teal.png', assetsPath + 'sprites/cars/racecar-teal.json')
    }

    create() {
        this.lights.enable();
        this.light = this.lights.addLight(this.scale.width / 2,this.scale.height / 2 - 20,  3000, 0xffffff, 1);
        this.setSelectedCar(this.carIndex, this.colorIndex);
        this.selectedCar.sprite.setLighting(true);
        this.selectedCar.sprite.play(this.selectedCar.drivingAnimation)
        this.selectedCarDriveToStage();

        this.selectionScene = this.scene.get('SelectionScene');

        this.selectionScene.events.on('moveToNextCar', (data) => {
            this.selectedCarDriveAway();
            this.carIndex++;
            if (this.carIndex >= this.carOptions.length) {
                this.carIndex = 0;
            }
            this.setSelectedCar(this.carIndex, this.colorIndex);
            this.selectedCarDriveToStage();
        })

        this.selectionScene.events.on('moveToPreviousCar', (data) => {
            this.selectedCarDriveAway();
            this.carIndex--;
            if (this.carIndex < 0) {     
                this.carIndex = this.carOptions.length - 1;
            }
            this.setSelectedCar(this.carIndex, this.colorIndex);
            this.selectedCarDriveToStage();
        })

        this.selectionScene.events.on('moveToNextColor', (data) => {
            this.selectedCarDriveAway();
            this.colorIndex++;
            if (this.colorIndex >= this.carOptions[this.carIndex].length) {
                this.colorIndex = 0;
            }
            this.setSelectedCar(this.carIndex, this.colorIndex);
            this.selectedCarDriveToStage();
        })

        this.selectionScene.events.on('moveToPreviousColor', (data) => {
            this.selectedCarDriveAway();
            this.colorIndex--;
            if (this.colorIndex < 0) {
                this.colorIndex = this.carOptions[this.carIndex].length - 1;
            }
            this.setSelectedCar(this.carIndex, this.colorIndex);
            this.selectedCarDriveToStage();
        })

        this.selectionScene.events.on('moveToStartingPosition', (data) => {
            this.selectedCarMoveToStartingPosition();
        })
    }

    setSelectedCar = (carIndex, colorIndex) => {
        this.carIndex = carIndex;
        this.colorIndex = colorIndex;
        this.selectedCar = this.carOptions[this.carIndex][this.colorIndex];
        if (this.selectedCar.sprite == null) {
            this.selectedCar.sprite = this.add.sprite(-64 * 5, this.carY, `${this.selectedCar.key}-atlas`, 0)
                    .setOrigin(0.5, 1)
                    .setScale(4).setLighting(true)

            this.anims.create({
                key: this.selectedCar.drivingAnimation,
                frames: this.anims.generateFrameNames(`${this.selectedCar.key}-atlas`, {
                    prefix: `${this.selectedCar.key} `,
                    start: 0,
                    end: 4,
                    zeroPad: 0,
                    suffix: '.aseprite'
                }),
                repeat: -1,
                frameRate: 20,
            })

        }
        this.selectedCar.sprite.play(this.selectedCar.drivingAnimation)
        return this.selectedCar;
    }

    selectedCarDriveToStage = () => {
        this.selectedCar.sprite.x = -64 * 5;
        this.selectedCar.sprite.play(this.selectedCar.drivingAnimation, true)
        this.tweens.add({
            targets: this.selectedCar.sprite,
            x: {
                from: this.selectedCar.sprite.x,
                to: this.scale.width / 2,
            },
            duration: 1500,
            ease: 'Linear',
            yoyo: false,
            onComplete: () => {
                this.events.emit('carSelectionActive', false);
            }
        })
    }

    selectedCarDriveAway = () => {
        this.selectedCar.sprite.play(this.selectedCar.drivingAnimation)
        this.tweens.add({
            targets: this.selectedCar.sprite,
            x: {
                from: this.selectedCar.sprite.x,
                to: this.selectedCar.sprite.x + this.scale.width + 64 * 5,
            },
            duration: 1500,
            ease: 'Linear',
            yoyo: false,
            onComplete: () => {
                this.events.emit('carSelectionActive', false);
            }
        })
        this.selectedCar.sprite.x = -64 * 5;
    }

    selectedCarMoveToStartingPosition = () => {
        this.tweens.add({
            targets: [this.selectedCar.sprite, this.light],
            x: {
                from: this.selectedCar.sprite.x,
                to: this.scale.width / 12 * 2,
            },
            y: {
                from: this.selectedCar.sprite.y,
                to: this.carY,
            },
            duration: 1000,
            ease: 'Linear',
            yoyo: false,
            onComplete: () => {
                this.events.emit('carSelectionActive', false);
            }
        })
    }

    removeExtras = () => {
        for(let i = 0; i < this.carOptions.length; i++) {
            for(let j = 0; j < this.carOptions[i].length; j++) {
                if(this.carOptions[i][j].key !== this.selectedCar.key) {
                    if (this.carOptions[i][j].sprite != null) {
                        this.carOptions[i][j].sprite.destroy();
                    }
                    this.textures.remove(this.carOptions[i][j].key + '-atlas');
                    this.anims.remove(this.carOptions[i][j].drivingAnimation);
                }
            }
        }
    }
}

export default CarSelection;